import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

export const useReopenCompanyForApproval = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['reopenForApproval']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.reopenForApproval,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      options?.onSuccess?.(...args)
    },
  })
}
